import {
	IMarkerWithZIndex,
	IPointWithOffset,
} from 'modules/admin-panel/pages/results/models';

export const getMarkersWithZIndex = (markers: IPointWithOffset[]) => {
	const checkedCoordinates: string[] = [];
	return markers.reduce((res, marker, _, arr) => {
		if (
			checkedCoordinates.includes(`${marker.longitude}, ${marker.latitude}`)
		) {
			return res;
		}
		checkedCoordinates.push(`${marker.longitude}, ${marker.latitude}`);

		const itemsWithSameCoordinates = arr.filter(
			(i) => i.latitude === marker.latitude && i.longitude === marker.longitude,
		);

		if (itemsWithSameCoordinates.length <= 1) {
			return [...res, marker];
		}

		const itemsWithZIndex = itemsWithSameCoordinates
			.sort((a, b) => {
				const countA = a.count || 0;
				const countB = b.count || 0;
				return countB - countA;
			})
			.map((item, index) => ({
				...item,
				zIndex: index + 1,
			}));

		return [...res, ...itemsWithZIndex];
	}, [] as IMarkerWithZIndex[]);
};
